var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{staticClass:"standalone-page",attrs:{"name":"main"}}),_c('router-view',{staticClass:"standalone-page",attrs:{"name":"login"}}),_c('router-view',{staticClass:"standalone-page",attrs:{"name":"aanmelden"}}),_c('router-view',{staticClass:"standalone-page",attrs:{"name":"bedankt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }